var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup419 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-3{fill:none}.cls-3{stroke:#486a41;stroke-linecap:round;stroke-width:1.5px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    transform: "translate(-97 -457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_647",
    d: "M0 0H50V50H0z",
    className: "cls-1",
    transform: "translate(97 457)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    transform: "translate(-1144 -193.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_116",
    fill: "#e3ebdc",
    stroke: "#486a41",
    transform: "translate(1249 658.945)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17,
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    transform: "translate(1261.06 665.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_47",
    d: "M0 0L10.342 0",
    className: "cls-3",
    transform: "translate(.221 20.683)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_48",
    d: "M0 0L0 16.997",
    className: "cls-3",
    transform: "translate(5.392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    fill: "none",
    stroke: "#486a41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    d: "M2687.647 2163.478l5.392 5.392 5.392-5.392",
    transform: "translate(-2687.647 -2151.872)"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup419);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Group 419.e153ec01edfc5f4dd9a7d2a5ecc4c083.svg";